<template>
    <div class="charge-warp">
        <div class="display-f just-b align-i-c">
            <el-form ref="form" :model="searchForm" inline>
                <el-form-item>
                    <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="searchForm.date" type="datetimerange" :default-time="['00:00:00', '23:59:59']"
                        :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                        align="right">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-input placeholder="医生姓名" v-model="searchForm.doctorName"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input placeholder="患者姓名" v-model="searchForm.patientName"></el-input>
                </el-form-item>
                <el-form-item>
                    <custom-button type="primary" @click="handleSearch">查询</custom-button>
                    <custom-button type="" @click="handleReset">重置</custom-button>
                </el-form-item>
            </el-form>
            <custom-button type="primary" plain @click="handleExport">导出</custom-button>

        </div>
        <div class="table-warp">
            <customTable :cell-style="{ borderColor: '#DDDDDD' }" height="600" tooltip-effect="dark" :currentPageSize="searchForm.pageSize"
                @pageChange="pageChange" :currentPage="searchForm.pageNum" :total="total" :tableData="tableData"
                :column="column" :header-cell-style="{ background: '#F0F1F3', borderColor: '#DDDDDD' }" border>
            </customTable>
        </div>
    </div>
</template>
  
<script>
import customTable from '@/components/customTable/customTable'
import { statementDTO, CommonDTO } from '@/DTO/index'
import { Utils } from '@/utils/utils'
import moment from 'moment';
import { isMoreThanOneYear, isNull, debounce,dictText } from '@/utils/validateBase'
import { sexDict,doctorVisitList } from '@/utils/const'
export default {
    // 定义引入的组件
    components: { customTable },
    props: {},
    data() {
        return {
            pickerOptions: {
                shortcuts: [{
                    text: '今日',
                    onClick(picker) {
                        const end = Utils.timeFormat(Number(Utils.endOfDay(moment())), 'yyyy-MM-DD HH:mm:ss')
                        const start = Utils.timeFormat(Number(Utils.startOfDay(moment())), 'yyyy-MM-DD HH:mm:ss')
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '昨日',
                    onClick(picker) {
                        let yesterday = moment().subtract(1, 'days')
                        const end = Utils.timeFormat(Number(Utils.endOfDay(yesterday)), 'yyyy-MM-DD HH:mm:ss')
                        const start = Utils.timeFormat(Number(Utils.startOfDay(yesterday)), 'yyyy-MM-DD HH:mm:ss')
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '本周',
                    onClick(picker) {
                        const end = Utils.timeFormat(Number(Utils.endOfDay(moment().endOf('isoWeek'))), 'yyyy-MM-DD HH:mm:ss')
                        const start = Utils.timeFormat(Number(Utils.startOfDay(moment().startOf('isoWeek'))), 'yyyy-MM-DD HH:mm:ss')
                        picker.$emit('pick', [start, end]);
                    }
                },
                {
                    text: '本月',
                    onClick(picker) {
                        const end = Utils.timeFormat(Number(Utils.endOfDay(moment().endOf('month'))), 'yyyy-MM-DD HH:mm:ss')
                        const start = Utils.timeFormat(Number(Utils.startOfDay(moment().startOf('month'))), 'yyyy-MM-DD HH:mm:ss')
                        picker.$emit('pick', [start, end]);
                    }
                },
                {
                    text: '本年',
                    onClick(picker) {
                        const end = Utils.timeFormat(Number(Utils.endOfDay(moment().endOf('year'))), 'yyyy-MM-DD HH:mm:ss')
                        const start = Utils.timeFormat(Number(Utils.startOfDay(moment().startOf('year'))), 'yyyy-MM-DD HH:mm:ss')
                        picker.$emit('pick', [start, end]);
                    }
                },
                ]
            },
            searchForm: {
                date: [],
                doctorName: '',
                doctorName: '',
                pageNum: 1,
                pageSize: 20,
                deptId: this.$session.get('deptId'),
            },//搜索条件
            tableData: [],//表格数据
            total: 0,//总数
            totalData: 0,//金额合计
            column: [
                { label: "医生", prop: "doctorName", align: 'left' },
                { label: "患者", prop: "patientName", align: 'left',width:100,showOverflowTooltip: true},
                { label: "性别", prop: "sex", align: 'left',formatter: (row) => {
                    return dictText(row.sex, sexDict)
                } },
                { label: "年龄", prop: "age", align: 'left' },
                { label: "手机号", prop: "phone", align: 'left',width:120 },
                { label: "初/复诊", prop: "doctorVisit", align: 'left',formatter: (row) => {
                    return dictText(row.doctorVisit, doctorVisitList)
                } },
                { label: "就诊日期", prop: "diagnosisDate", align: 'left',width:100, },
                { label: "就诊时间", prop: "diagnosisTime", align: 'left',},
                { label: "主诉", prop: "patientTell", align: 'left',showOverflowTooltip: true ,width:200},
                { label: "现病史", prop: "presentCondition", align: 'left',showOverflowTooltip: true ,width:200},
                { label: "既往病史", prop: "previousHistory", align: 'left',showOverflowTooltip: true,width:200 },
                { label: "望闻问切", prop: "facePalpation", align: 'left' ,showOverflowTooltip: true,width:200},
                { label: "辩证", prop: "dialectical", align: 'left',showOverflowTooltip: true,width:200 },
                { label: "诊断", prop: "diagnosis", align: 'left' ,showOverflowTooltip: true,width:200},
                { label: "开方剂量", prop: "doseNum", align: 'left' },
                { label: "开单费用", prop: "amount", align: 'center' },
                { label: "处方类型", prop: "recipeType", align: 'left', width:120 },
                { label: "处方明细", prop: "itemName", align: 'left',showOverflowTooltip: true,width:200 },
                { label: "用法", prop: "recipeMethod", align: 'left',showOverflowTooltip: true },
                { label: "用量", prop: "doseFrequency", align: 'left'},
                { label: "频次", prop: "frequency", align: 'left' },
                { label: "每次用量", prop: "takingDosage", align: 'left',showOverflowTooltip: true },
                { label: "医嘱事项", prop: "doctorAdvice", align: 'left' ,showOverflowTooltip: true},
                { label: "加工方式", prop: "processName", align: 'left'},
                { label: "日服药价", prop: "amountPerday", align: 'center' },
                { label: "状态", prop: "status", align: 'left' },
                { label: "购买剂量", prop: "realDoseNum", align: 'left' },
                { label: "复诊提醒", prop: "revisitInfo", align: 'left' },
                { label: "复诊备注", prop: "revisitNotes", align: 'left' },
            ],//表头
        }
    },
    //变量监听
    watch: {},
    // 页面初始化
    created() {
        let time = CommonDTO.getSystemTimeDTO()
        let startOfDay = Number(Utils.startOfDay(this.$moment(time)))
        let endOfDay = Number(Utils.endOfDay(this.$moment(time)))
        this.searchForm.date[0] = Utils.timeFormat(startOfDay, 'yyyy-MM-DD HH:mm:ss')
        this.searchForm.date[1] = Utils.timeFormat(endOfDay, 'yyyy-MM-DD HH:mm:ss')
        this.getPrescribePage()
    },
    // 页面DOM加载完成
    mounted() { },
    //离开页面时执行
    destroyed() { },
    // 页面方法
    methods: {
        /**
         * 页码改变
         */
        pageChange(obj) {
            let { current, size } = obj
            this.searchForm.pageNum = current
            this.searchForm.pageSize = size
            this.getPrescribePage()
        },
        /**
         * 重置
         */
        handleReset() {
            this.searchForm = {
                date: [],
                searchValue: '',
                pageNum: 1,
                pageSize: 20,
                deptId: this.$session.get('deptId'),
            }
            let time = CommonDTO.getSystemTimeDTO()
            let startOfDay = Number(Utils.startOfDay(this.$moment(time)))
            let endOfDay = Number(Utils.endOfDay(this.$moment(time)))
            this.searchForm.date[0] = Utils.timeFormat(startOfDay, 'yyyy-MM-DD HH:mm:ss')
            this.searchForm.date[1] = Utils.timeFormat(endOfDay, 'yyyy-MM-DD HH:mm:ss')
            this.getPrescribePage()
        },

        /**
         * 搜索
         */
        handleSearch() {
            this.searchForm.pageNum = 1
            let flag = isMoreThanOneYear(this.searchForm.date[0], this.searchForm.date[1], 366)
            if (flag) return this.$message.error('时间范围不能超过一年')
            // let HH = this.$moment().get('hour')
            // let flagOneDay = isMoreThanOneYear(this.searchForm.date[0], this.searchForm.date[1], 1)
            // if(flagOneDay && HH < 22 && HH > 7 ) return this.$message.error('当前选择的日期范围大于1天，请22:00后查询')
            this.getPrescribePage()
        },

        /**
         * 查询执行业绩
         */
        async getPrescribePage() {
            this.searchForm.startTime = this.searchForm.date[0]
            this.searchForm.stopTime = this.searchForm.date[1] 
            let { code, rows, total } = await statementDTO.prescribePage(this.searchForm)
            if (code == 200) {
                this.tableData = rows
                this.total = total
            }
        },

        /**
        * 导出
        */
        handleExport: debounce(function () {
            this.searchForm.startTime = this.searchForm.date[0]
            this.searchForm.stopTime = this.searchForm.date[1] 
            statementDTO.exportPrescribe(this.searchForm, { name: '开方统计',type:'csv' }).then(res => {
             })
        }, 1000, true),

    },
}
</script>
<style lang="less" scoped>
.charge-warp {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: auto;

    .el-form-item {
        margin-bottom: 0;
    }

    .table-warp {
        margin-top: 16px;
        flex: 1;

        /deep/.el-table {
            border-color: #DDDDDD;
        }

        /deep/.pagination-wrap {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-left: 0;

            .total-tips {
                color: #667182;
                font-size: 14px;
            }
        }
    }
}
</style>